// Shared CRM (Prompt 8) constants + color maps + helpers.
export const NAVY = "#1C4358", RED = "#9C1E22", GREEN = "#2F7D5A", AMBER = "#B7791F",
  SKY = "#2C6480", PURPLE = "#7C3AED", GRAY = "#6B7280", BLUE = "#2563EB";

export const pretty = (s) =>
  String(s == null ? "" : s).replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());

// Service lanes used across pipeline + opportunities.
export const LANES = [
  { value: "sell_home", label: "Selling the Home" },
  { value: "senior_placement", label: "Senior Living Placement" },
  { value: "home_safety", label: "Keep Mama Home" },
  { value: "move_into_my_home", label: "Move Mama In" },
  { value: "downsizing", label: "Downsizing & Estate" },
  { value: "home_repairs", label: "Home Repairs" },
  { value: "partner_referral", label: "Partner Referral" },
];

export const REL_STATUS_HEX = {
  new: GRAY, contacted: SKY, interested: BLUE, active_partner: GREEN, referral_sent: GREEN,
  needs_follow_up: AMBER, paused: AMBER, not_a_fit: RED, closed_inactive: GRAY,
};

export const OPP_STAGE_HEX = {
  opportunity_identified: SKY, partner_needed: AMBER, partner_introduced: BLUE, estimate_pending: AMBER,
  contract_pending: AMBER, work_active: BLUE, revenue_pending: PURPLE, closed_won: GREEN,
  closed_lost: GRAY, long_term_follow_up: GRAY,
};

export const REVENUE_HEX = {
  not_started: GRAY, pending: AMBER, invoice_needed: AMBER, invoiced: BLUE, partially_received: BLUE,
  received: GREEN, closed_no_revenue: GRAY, cancelled: RED,
};

export const CHART_COLORS = [NAVY, RED, GREEN, AMBER, SKY, PURPLE, BLUE, "#C2620F", "#5A5E2E", "#9AA5B1"];

export const hexWithAlpha = (hex, a) => {
  const h = hex.replace("#", "");
  const r = parseInt(h.slice(0, 2), 16), g = parseInt(h.slice(2, 4), 16), b = parseInt(h.slice(4, 6), 16);
  return `rgba(${r},${g},${b},${a})`;
};
